<template>
  <div class="account_panel">
    <el-scrollbar class="panel">
      <el-checkbox-group v-model="checkGroupList"
                         @change="handleSelectionChange">
        <span class="group-item"
              v-for="item in groupData"
              :key="item.workGroupName"
              :title="item.workGroupName">
          <el-checkbox :label="item.workGroupName"></el-checkbox>
        </span>
      </el-checkbox-group>
    </el-scrollbar>

    <el-scrollbar class="panel margin-left-10">
      <div v-for="(item,index) in executeTeams"
           :key="index"
           style="height:100%">
        <div class="user-item user-group-item">{{item.workGroupName}}</div>
        <div class="user-item"
             v-for="(executor,executorIndex) in item.executor"
             :key="item.executor[executor]">
          <div class="user-item-txt"><span :title="executor">{{executor}}</span></div>
          <div class="user-item-delete el-icon-delete pointer"
               @click="deleteAccount(index,executorIndex)"></div>
          <div class="clear"></div>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>
<script>
export default {
  props: {
    subTaskInfoList: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      groupData: [],
      executeTeams: [],
      checkGroupList: [],
      // 不同用户组的用户信息，发送一次请求后保存下来
      groupAccountData: {},
      // 之前勾选的数组
      prevCheckList: [],
      groupCode: ''
    }
  },
  methods: {
    // 数据回填
    dealData () {
      this.groupData = [];
      this.executeTeams = [];
      this.checkGroupList = [];
      this.prevCheckList = [];
      console.log('appAcountGroup=>dealData:', this.subTaskInfoList);
      if (this.subTaskInfoList.length) {
        // 获取组信息后回填
        this.queryAccoutGroup().then(() => {
          this.subTaskInfoList.map(item => {
            if (this.checkGroupList.findIndex(group => group == item.workGroupName) == -1) {
              this.checkGroupList.push(item.workGroupName);
              this.executeTeams.push({
                workGroupCode: item.workGroupCode,
                workGroupName: item.workGroupName,
                executor: [item.executor],
                executorName: [item.executor],
                userFrom: 0
              })
            } else {
              let executeTeamsIndex = this.executeTeams.findIndex(executeTeams => executeTeams.workGroupName == item.workGroupName);
              this.executeTeams[executeTeamsIndex].executor.push(item.executor);
              this.executeTeams[executeTeamsIndex].executorName = this.executeTeams[executeTeamsIndex].executor;
            }
          });
        });
      }
      this.prevCheckList = this.checkGroupList;
    },
    // 根据缓存信息为用户组赋值已有账户
    getExecutor (item) {
      // 当前所有已请求用户组下用户信息
      if (this.groupAccountData[item.workGroupCode]) {
        // 获取对应账户昵称
        let executor = [];
        this.groupAccountData[item.workGroupCode].map(item => {
          executor.push(item.accountNumber);
        })
        // 给对应勾选组赋值
        this.executeTeams.map(teams => {
          if (teams.workGroupCode === item.workGroupCode) {
            teams.executor = teams.executorName = executor;
          }
        })
        return false;
      }
      return true;
    },
    // 根据账户组信息查询账户信息
    handelAccoutGroup (item) {
      return new Promise((resolve, reject) => {
        try {
          if (!this.getExecutor(item)) return;
          this.groupAccountData[item.workGroupCode] = item.accounts;
          this.getExecutor(item);
          // this.$fetch('/cms/accountGroup/getAccountByAccountGroup.json',{workGroupCode:item.workGroupCode}).then((response) => {
          //     if(response.success) {
          //         resolve(true);
          //     }else{
          //         reject("error")
          //     }
          // })
        } catch (e) {
          console.log(e);
        }
      });
    },
    // 查询账户组信息
    queryAccoutGroup () {
      this.groupData = [];
      return new Promise((resolve, reject) => {
        try {
          this.$fetch('/cms/workGroup/queryWorkGroupByAreaOrDevice.json', { areaCode: [this.groupCode] }).then((response) => {
            if (response.success) {
              this.groupData = response.returnObj
              resolve(true);
            } else {
              reject(false);
            }
          })
        } catch (err) {
          reject(false);
        }
      });
    },
    deleteAccount (accountGroupIndex, index) {
      this.executeTeams[accountGroupIndex].executorName.splice(index, 1);
      this.executeTeams[accountGroupIndex].executor = this.executeTeams[accountGroupIndex].executorName;
      if (this.executeTeams[accountGroupIndex].executor.length == 0) {
        this.checkGroupList.splice(this.checkGroupList.findIndex(group => group == this.executeTeams[accountGroupIndex].workGroupName), 1);
        this.executeTeams.splice(accountGroupIndex, 1);
      }
    },
    handleSelectionChange (val) {
      // 用之前勾选的数组与当前数组对比，获得当前勾选值
      let checkedGroup = Array.from(new Set([...new Set(val)].filter(x => !new Set(this.prevCheckList).has(x))));
      // 用之前勾选的数组与当前数组对比，获得当前取消勾选值
      let uncheckedGroup = Array.from(new Set([...new Set(this.prevCheckList)].filter(x => !new Set(val).has(x))));
      // 增加
      if (checkedGroup.length > 0) {
        // 获取勾选组信息
        let teamsIndex = this.groupData.findIndex(item => item.workGroupName == checkedGroup[0]);
        if (teamsIndex == -1) return;
        this.executeTeams.push({
          workGroupCode: this.groupData[teamsIndex].workGroupCode,
          workGroupName: this.groupData[teamsIndex].workGroupName,
          executor: [],
          executorName: [],
          userFrom: 0
        })
        // 获取用户信息
        this.handelAccoutGroup(this.groupData[teamsIndex]);
      } else if (uncheckedGroup.length > 0) {
        // 删除整个组
        let teamsIndex = this.executeTeams.findIndex(item => item.workGroupName == uncheckedGroup[0])
        if (teamsIndex == -1) return;
        this.executeTeams.splice(teamsIndex, 1);
      }
      this.prevCheckList = val;
    },
  }
}
</script>

<style lang='scss'>
@import "~@src/common/assets/style/mixin";
.account_panel {
  height: 100%;
  padding: 0 10px;
  display: flex;
  flex-direction: row;

  .panel {
    flex: 1;
    @include set_theme_color(background-color, left-menu-bg-color);
    background-color: #1a1f2b;
    border-color: #596f94;
    // height: 100%;

    &.margin-left-10 {
      margin-left: 10px;
    }

    .el-scrollbar__wrap {
      overflow-x: hidden;
    }

    .el-scrollbar__view {
      padding-bottom: 15px;
    }
    .group-item {
      display: block;
      line-height: 30px;
      cursor: pointer;
      text-align: left;
      padding-left: 20px;
      border-bottom: 1px solid #23395e;

      &.active {
        background-color: #23395e;
      }
    }
    .user-group-item.user-item {
      color: #f0f000;
      font-weight: bolder;
      padding-left: 10px;
    }
    .user-item {
      clear: both;
      line-height: 30px;
      padding-left: 20px;
      .user-item-txt {
        float: left;
        width: 79%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        height: 30px;
      }
      .user-item-delete {
        float: right;
        width: 20%;
        height: 30px;
        line-height: 30px;
      }
    }
  }
}
</style>
